<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 11 11" :class="[`${prefix}-icon`, `${prefix}-icon-star`]" width="1em" height="1em" v-bind="$attrs"><path d="M10.9998,4.31661C10.9998,3.28261,8.12031,3.21661,7.73531,2.76508C7.35013,2.31337,6.29466,0,5.49982,0C4.70516,0,3.65218,2.30574,3.26753,2.75124C2.88271,3.19674,0,3.27711,0,4.31661C0,5.12529,1.24885,6.27567,1.80116,6.96317C3.02082,5.03315,5.14191,3.85992,7.425,3.85248C4.675,3.85248,2.82984,6.49922,1.95818,8.11941C1.79016,9.02461,1.50398,10.4276,1.78768,10.6973C2.80589,11.6637,5.01369,10.007,5.5,10.007C5.98649,10.007,8.195,11.657,9.2125,10.6973C9.59448,10.3345,8.9375,7.8799,8.9375,7.41808C8.9375,6.95608,11,5.35167,11,4.31732L10.9998,4.31661Z"/></svg>
</template>
<script>

export default {
  name: 'IconStar',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
